import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { ferr, Badge, money, date, Table } from "../shared";

export default function TransactionsPanel() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const load = useCallback(async () => {
    setLoading(true);
    try { const { data } = await api.get("/admin/transactions"); setRows(data); }
    catch (e) { ferr(e, "Failed to load transactions."); } finally { setLoading(false); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const refund = async (t) => {
    if (!window.confirm(`Refund ${money(t.amount)} to ${t.email}?`)) return;
    try { const { data } = await api.post(`/admin/transactions/${t.session_id}/refund`); toast.success(`Refund ${data.status}.`); load(); }
    catch (e) { ferr(e, "Refund failed."); }
  };
  return (
    <div data-testid="admin-transactions">
      <Table cols={["Date", "Customer", "Property", "Amount", "Status", ""]} loading={loading} empty={!rows.length}>
        {rows.map((t) => (
          <tr key={t.session_id} className="border-t border-gravel hover:bg-fieldstone" data-testid={`admin-tx-row-${t.session_id}`}>
            <td className="td whitespace-nowrap text-[12px]">{date(t.created_at)}</td>
            <td className="td">{t.email}</td>
            <td className="td max-w-[200px] truncate">{t.address || "—"}</td>
            <td className="td">{money(t.amount)}</td>
            <td className="td"><Badge value={t.payment_status} /></td>
            <td className="td text-right">
              {t.payment_status === "paid" && !t.refunded && (
                <button onClick={() => refund(t)} className="text-rose-600 text-[12px] font-bold hover:underline" data-testid={`admin-tx-refund-${t.session_id}`}>Refund</button>
              )}
            </td>
          </tr>
        ))}
      </Table>
    </div>
  );
}
